/** @module Classes */ /** typedoc */
// The real Max paypal allowed amount is 10k$ and max fees 20$ (but we allow 9500$ max to stay under the limit)
const MaxPaypalPayoutAmount = 9520;
// The real Max Paypal allowed amount for Japanese users is ¥1000000 or $9000 USD and max fees $20 (but we allow $8500 max to stay under the limit)
const MaxPaypalPayoutAmountForJapanese = 8520;
class ReleasePayout {
    constructor() {
        this.id = null;
        this.creationTime = null;
        this.recipients = [];
    }
}
class ReleasePayoutRecipient {
    constructor() {
        this.amount = null;
        this.fee = null;
        this.email = null;
        this.status = null;
        this.globalStatus = null;
    }
}

export { MaxPaypalPayoutAmount, MaxPaypalPayoutAmountForJapanese, ReleasePayout, ReleasePayoutRecipient };
